import { authorsMatch } from './authorsMatch';
import type { ResponseAuthorIdentity } from './ResponseAuthorIdentity';

export const shouldShowAgentResponseHat = ({
	currentAuthor,
	previousAuthor,
}: {
	currentAuthor: ResponseAuthorIdentity;
	previousAuthor?: ResponseAuthorIdentity;
}): boolean => {
	if (!previousAuthor) {
		return false;
	}

	return !authorsMatch(currentAuthor, previousAuthor);
};
